import ComponentsWithCountryData from "./app/basic/ComponentsWithCountryData";
import CountryInput from "./app/basic/CountryInput";

let __isReadyExecuted = false;
const __readyInvokeEventTypes = ['mousemove', 'keydown', 'touchstart'];

function ready() {
    if (__isReadyExecuted) {
        return;
    }
    __isReadyExecuted = true;
    // прослушка событий больше не нужна
    __readyInvokeEventTypes.forEach(eventType => window.removeEventListener(eventType, ready));
    require.ensure(['./noAuth_v2.js'], function (require) {
        require('./noAuth_v2.js');
    }, 'noAuthSuspend');
}

// отложенная загружка 1900 ms если пользователь открыл сайт и ничего не делает (отложенность нужна для PageSpeed Insight)
window.addEventListener("load", () => { setTimeout(ready, 1900) });

// так как приходится дополнительно сдвигать загрузку скрпита, после события "load" для PageSpeed Insight, то для реального пользователя, если он что то начинает делать, загружаем быстрее
__readyInvokeEventTypes.forEach(eventType => window.addEventListener(eventType, ready));
const componentsWithCountry = new ComponentsWithCountryData();
componentsWithCountry.render();